/* fetch has to be ponyfilled directly because of mocked node contexts during hydrate */
import fetch from 'cross-fetch';
import { DomService } from '../dom';

export const TranslationService = {
  async fetchTranslation(endpoint: string): Promise<unknown> {
    if (!endpoint) {
      return {};
    }

    return fetch(endpoint)
      .then((result) => result.json(), () => ({}))
      .then(
        (data) => {
          sessionStorage.setItem(endpoint, JSON.stringify(data));
          return data;
        },
        () => ({}),
      );
  },
  async getTranslation(locale?: string, translationSourceUrl?: string): Promise<unknown> {
    const { locale: defaultLocale, translationUrl } = DomService.getGlobalConfig();
    const url = translationSourceUrl || translationUrl;

    const localizedTranslationUrl = locale
      ? url?.replace(`${defaultLocale}.json`, `${locale}.json`)
      : url;

    const translation = JSON.parse(sessionStorage.getItem(`${localizedTranslationUrl}`)) || await this.fetchTranslation(localizedTranslationUrl);
    return translation || {};
  },
  async translate(key: string, locale?: string, translationSource?: string): Promise<string> {
    return (await this.getTranslation(locale, translationSource))[key] || key;
  },
};
